import React from "react"
import { useTranslation } from "react-i18next"
import * as XLSX from "xlsx"
import i18next from "i18next"
import dateService from "services/date"

import { DownloadIcon } from "components/Elements/Icons"

export const ExportData = ({
	selectedDatas,
	datas,
	disabled,
}) => {
	const { t } = useTranslation()

	const exportPartners = (selectedDatas) => {
		
		// Filter bikes'list from original list
		const selectedPartners = datas.filter((partner) => {
			return selectedDatas.some((selectedPartner) => {
				return partner.client_number === selectedPartner.values.client_number
			})
		})

		if (selectedPartners) {
			// We extract operators from array into a string field
			// We delete keywords property
			selectedPartners.map((partner) => {
				partner.operators = partner.operators.toString()
				partner.createDate = dateService.formatDate(partner.createDate, "dd/MM/y")
				delete partner.keywords

				return partner
			})

			// prepare xlsx
			const wb = XLSX.utils.book_new()

			// Heading with translations
			const Heading = [
				i18next.t("edit.state_of_ref", { ns: "partner" }),
				i18next.t("profil.social_reason", { ns: "partner" }),
				i18next.t("profil.commercial_name", { ns: "partner" }),
				i18next.t("profil.siret", { ns: "partner" }),
				i18next.t("store.address", { ns: "partner" }),
				i18next.t("profil.postal_code", { ns: "partner" }),
				i18next.t("profil.town", { ns: "partner" }),
				i18next.t("edit.declarator_number", { ns: "partner" }),
				i18next.t("profil.e-mail", { ns: "partner" }),
				i18next.t("profil.firstname", { ns: "team" }),
				i18next.t("profil.name", { ns: "team" }),
				i18next.t("profil.phone", { ns: "partner" }),
				i18next.t("edit.operator_for", { ns: "partner" }) + "(s)",
				i18next.t("profil.client_number", { ns: "partner" }) + " MFC",
				i18next.t("specificity", { ns: "partner" }) + " MFC",

				i18next.t("type", { ns: "partner" }),
				i18next.t("isFranchise", { ns: "partner" }),
				i18next.t("store.structure_chain_name", { ns: "partner" }),
				i18next.t("edit.afub-member", { ns: "partner" }),
			]

			const fname = "export-liste-partenaires"

			const ws = XLSX.utils.json_to_sheet(selectedPartners)

			XLSX.utils.sheet_add_json(ws, [], {
				origin: "A1",
				header: Heading,
			})

			XLSX.utils.book_append_sheet(wb, ws, i18next.t("list.export_partners", { ns: "partner" }))
			XLSX.writeFile(wb, fname + ".xlsx")
		}				
	}

	return (
		<button
			type="button"
			onClick={() => exportPartners(selectedDatas)}
			className="c-btn c-btn--primary px-7"
			disabled={disabled}
		>
			<DownloadIcon size={20} className="u-mg-right-s" />
			{t("list.export_partners", { ns: "partner" })} ({selectedDatas.length})
		</button>
	)
}
